import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/daisy';
import { Colors, Sizes } from '@/components/ui/types';
import { ExamTypeEnum } from '@/models/Exam';

type ExamTypeBadgeProps = {
  type: ExamTypeEnum;
  size: Sizes;
};

const typeToColor: Record<ExamTypeEnum, Colors> = {
  [ExamTypeEnum.TEST]: 'primary',
  [ExamTypeEnum.SIMULATED]: 'secondary',
};

export default function ExamTypeBadge({ type, size }: ExamTypeBadgeProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'examTypes',
  });

  return (
    <Badge
      color={typeToColor[type]}
      size={size}
      className="text-nowrap"
    >
      {t(type)}
    </Badge>
  );
}
